module.exports = __webpack_public_path__ + "img/yahoo-20210817.74d31eeb.jpg";